import(/* webpackMode: "eager" */ "/codebuild/output/src52593423/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
